import { Component, HostListener, ElementRef, viewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { MisdatosService } from '../services/misdatos.service';
import Swal from 'sweetalert2';
import { QueryService } from '../services/query.service';
import { GlobalConstants } from '../global-constants';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrl: './user.component.css'
})
export class UserComponent {
  private misdatosSub!: Subscription;
  misdatos: any = {};
  // Estado para controlar si el popup está abierto o cerrado
  isPopupOpen = false;

  constructor(
    public misdatosService: MisdatosService,
    private elementRef: ElementRef,
    private query: QueryService
  ) {}

  ngOnInit() {
    // Escuchamos el observable de misdatos
    this.misdatosSub = this.misdatosService.misdatos$
      .pipe(
        // 2. FILTRO: Si es null, no pasa. Solo continúa si tiene datos reales.
        filter((misdatos): misdatos is any => misdatos !== null),
      )
      .subscribe((misdatos: any) => {
        // Ya tenemos datos
        this.misdatos = misdatos;
      });
  }

  togglePopup(event: Event): void {
    event.stopPropagation(); // Evitamos que el clic se propague al document
    this.isPopupOpen = !this.isPopupOpen;
  }

  // Escucha todos los clics que ocurren en la aplicación
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    // Si el clic ocurrió fuera del propio componente, cerramos el popup
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.isPopupOpen = false;
    }
  }

  cerrarSesion(): void {
    this.isPopupOpen = false;
    Swal.fire({
      title: 'Confirmación',
      text: '¿Quieres cerrar tu sesión de usuario?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Me quedo',
      cancelButtonText: 'Sí',
      customClass: {
        confirmButton: 'custom-swal-confirm',
        //cancelButton: 'custom-swal-cancel'
      },
    }).then((result) => {
      if (result.isConfirmed) {
      }
      if (result.isDismissed && result.dismiss === Swal.DismissReason.cancel) {
        this.query.query('misdatos', 'LOGOUT', null).subscribe((resultado:any) => {
          window.location.href = GlobalConstants.urlServer;
        });
      }
    });
  }  
}
